export enum InsightsVariant {
  Positive = 'positive',
  Negative = 'negative',
}
